<div class="order-complete-wrapper">
  <button
    mat-icon-button
    class="close-btn"
    (click)="onClose()"
    aria-label="Close"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div class="order-complete-card">
    <div
      id="success-lottie"
      style="width: 260px; height: 260px"
      class="mx-auto"
    ></div>

    <h2 class="title">
      {{ heading }}
    </h2>

    <p class="subtitle">
      {{ message }}
    </p>

    <button
      mat-flat-button
      color="primary"
      class="action-btn"
      (click)="onClose()"
    >
      OK
    </button>
  </div>
</div>

